import useIdentity from './useIdentity';

const useIsAdmin = (): boolean => {
  const {data} = useIdentity();
  return Boolean(data?.me?.adminAccount?.id);
};

export default useIsAdmin;
